import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";

const actions = {
  getInputs({ commit }, payload) {
    return api.fetch(endpoints.BATCH_HEADERS, payload, commit, (response) => {
    });
  },

  deleteInput({ commit }, payload) {
    return api.remove(
      endpoints.BATCH + "/" + payload.batch_uuid + "?department_uuid=" + payload.department_uuid,
      payload,
      commit,
      (response) => {},
    );
  },
};

export default actions;
